"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ReactMultiselectCheckboxes.default;
  }
});

var _ReactMultiselectCheckboxes = _interopRequireDefault(require("./ReactMultiselectCheckboxes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }